module.exports = __webpack_public_path__ + "static/media/whisky_hero_twitter_card.7d0a0de6.jpg";